import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "icp-form-designer" */
      /* webpackPrefetch: true */
      './FormDesigner'
    ),
);

export const PageDesigner = loadable(
  () =>
    import(
      /* webpackChunkName: "icp-form-designer" */
      /* webpackPrefetch: true */
      './PageDesigner'
    ),
);

export { createFormEntityByLayout } from './store/features/formEntitySlice';
export * from './utils';
export { ensureSchemaSatisfies, generateFormByText } from './AIAgent/utils';
export { dataSourceToColumnDefs } from './DesignerSettings/fieldSettings/TableSettings/utils';
export { makeNewField, Converter, extractDataFieldsFromSchema } from './store/utils';
export { ICP_DOC_DOMAIN } from './constant';
